import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as records from '../../records'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the service centers list whenever functional usage is successfully
 * updated. This refreshes the Linked Space Records Count column in the grid,
 * which reflects the number of space records this service center is assigned
 * to in functional usage.
 */
export const reloadOnFunctionalUsageChange = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: Collection,
    recordsCollection: records.Collection,
  ) =>
    recordsCollection.plugins
      .lookup(records.plugins.functionalUsage.Plugin)
      .get()
      .feature.actions.applyUpdates.success.observe()
      .pipe(
        rxjs.map(() =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from('(effect) reload service centers on functional usage change')
            .create(),
        ),
      ),
)
